<div class="success-stories hidden">
  <h1 class="ui-heading-1-bold success-stories-title">
    {{ knowledgeSection() }}
  </h1>

  <div class="success-stories-content">
    @for(s of successStories(); track $index) {
      @if(s.published === true) {
      <div class="success-stories-item">
        <h3 class="ui-heading-3">{{ s.title }}</h3>
        <div [innerHTML]="s?.description | safeHtml"></div>
      </div>
      }
    }
  </div>
</div>
